import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import FormItem from 'js/components/Form/FormItem'
import Spacer from 'js/components/Spacer/Spacer'

const General = ({ guid }) => {
    const { t } = useTranslation()

    const { control, watch } = useFormContext()

    const layoutOptions = [
        {
            value: 'button',
            label: t('global.button'),
        },
        {
            value: 'form',
            label: t('global.form'),
        },
    ]
    const buttonSizeOptions = [
        { value: 'sm', label: t('size.sm') },
        { value: 'md', label: t('size.md') },
        { value: 'lg', label: t('size.lg') },
    ]

    const buttonAlignmentOptions = [
        { value: 'left', label: t('position.left') },
        { value: 'center', label: t('position.center') },
        { value: 'right', label: t('position.right') },
    ]

    const watchLayout = watch('layout')

    return (
        <Spacer spacing="small">
            <FormItem
                control={control}
                type="radio"
                name="layout"
                id={`layout-${guid}`}
                title={t('widget.layout')}
                description={t('widget-create-content.layout-helper')}
                options={layoutOptions}
                size="small"
            />

            {watchLayout === 'button' ? (
                <>
                    <FormItem
                        control={control}
                        type="select"
                        name="buttonSize"
                        key={`buttonSize-${guid}`} // Force re-render
                        id={`buttonSize-${guid}`}
                        title={t('widget-create-content.button-size')}
                        options={buttonSizeOptions}
                    />
                    <FormItem
                        control={control}
                        type="select"
                        name="buttonAlignment"
                        key={`buttonAlignment-${guid}`} // Force re-render
                        id={`buttonAlignment-${guid}`}
                        title={t('widget-create-content.button-alignment')}
                        options={buttonAlignmentOptions}
                    />
                </>
            ) : (
                <>
                    <FormItem
                        control={control}
                        type="text"
                        name="title"
                        key={`title-${guid}`} // Force re-render
                        id={`title-${guid}`}
                        title={t('form.title')}
                        description={t('widget-create-content.title-helper')}
                    />
                    <FormItem
                        control={control}
                        type="textarea"
                        name="description"
                        key={`description-${guid}`} // Force re-render
                        id={`description-${guid}`}
                        title={t('form.description')}
                        description={t(
                            'widget-create-content.description-helper',
                        )}
                        size="small"
                    />
                </>
            )}
        </Spacer>
    )
}

export default General
